import React from 'react'
import PropTypes from 'prop-types'

const FullWidthContainer = (props) =>
    <div {...props}>
        {props.children}
    </div>

FullWidthContainer.propTypes = {

}

export default FullWidthContainer


// WEBPACK FOOTER //
// ./src/components/_common/_containers/FullWidthContainer/FullWidthContainer.js